<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import { applyPortalBrand } from "@/portal/branding";

export default {
  name: "App",
  async created() {
    applyPortalBrand();
    await this.$store.dispatch('initialize');
  }
}
</script>

<style lang="scss">
</style>
